import { render, staticRenderFns } from "./ContentToggler.vue?vue&type=template&id=25b46d8f&lang=pug"
import script from "./ContentToggler.vue?vue&type=script&lang=js"
export * from "./ContentToggler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports